import React from 'react';
import styled from 'styled-components';
import { Loading } from '../../components/Loading';

export const Button = React.forwardRef(
	(
		{
			value,
			type,
			$backgroundColor,
			$border,
			color,
			children,
			onClick,
			onSubmit,
			disabled,
			$width,
			$buttonSize,
			$minWidth,
			$maxWidth,
			$isLoading,
			...props
		}: ButtonProps,
		ref: any
	): JSX.Element => {
		return (
			<StyledButton
				ref={ref}
				type={type}
				$backgroundColor={$backgroundColor}
				$border={$border}
				$color={color}
				$width={$width}
				$minWidth={$minWidth}
				$maxWidth={$maxWidth}
				onSubmit={onSubmit && onSubmit}
				onClick={onClick && onClick}
				disabled={disabled || $isLoading}
				$buttonSize={$buttonSize}
				$isLoading={$isLoading}
				{...props}
			>
				{$isLoading ? (
					<Loading
						size={$buttonSize === 'small' ? 20 : 24}
						marginBottom={0}
						height={'auto'}
					/>
				) : (
					children
				)}
			</StyledButton>
		);
	}
);

export default Button;

const StyledButton = styled.button<ButtonProps>`
	min-width: ${props => (props.$buttonSize === 'small' ? '124px' : '140px')};
	min-height: 40px;
	width: ${({ $width }) => ($width ? $width : 'fit-content')};
	min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '140px')};
	max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 'unset')};
	color: ${({ $color }) => ($color ? $color : '#fff')};
	background-color: ${props =>
		props.disabled || props.$isLoading
			? '#d9d9d9'
			: props.$backgroundColor
				? props.$backgroundColor
				: '#f47920'};
	border: none;
	outline: ${({ $border }) => ($border ? $border : 'none')};
	font-weight: 500;
	border-radius: 4px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
	padding: 8px 16px;
	&:focus {
		outline: ${({ $border }) => ($border ? $border : 'none')};
	}
	text-align: center;
	font-size: ${props => (props.$buttonSize === 'small' ? '14px' : '16px')};

	&:hover {
		cursor: pointer;
	}
	&:disabled {
		cursor: not-allowed;
	}
`;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	type?: 'submit' | 'reset' | 'button';
	onClick?: (e: any) => void | Promise<void> | null;
	onSubmit?: (e: any) => void | null;
	$backgroundColor?: string;
	$border?: string;
	$color?: string;
	children?: any;
	disabled?: boolean;
	$minWidth?: string;
	$maxWidth?: string;
	$buttonSize?: 'small' | null;
	$isLoading?: boolean;
	$width?: string;
}
